/**
 * Messages for ContentsItem components
 * @module messages/contentsItemMessages
 */

import { defineMessages } from 'react-intl';

export const contentsItemMessages = defineMessages({
  // Workflow states - used in ContentsItemCell for review_state
  private: {
    id: 'private',
    defaultMessage: 'Private',
  },
  pending: {
    id: 'pending',
    defaultMessage: 'Pending',
  },
  published: {
    id: 'published',
    defaultMessage: 'Published',
  },
  intranet: {
    id: 'intranet',
    defaultMessage: 'Intranet',
  },
  draft: {
    id: 'draft',
    defaultMessage: 'Draft',
  },
  no_workflow_state: {
    id: 'no workflow state',
    defaultMessage: 'No workflow state',
  },
  // General messages - used in ContentsItemCell
  none: {
    id: 'None',
    defaultMessage: 'None',
  },
  // Image metadata - used in ContentsItemCell for image type
  dimensions: {
    id: 'Dimensions',
    defaultMessage: 'Dimensions',
  },
  size: {
    id: 'Size',
    defaultMessage: 'Size',
  },
});
